import { useTheme } from "next-themes"
import { Toaster as Sonner } from "sonner"

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      position="bottom-right"
      closeButton
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-white group-[.toaster]:text-black group-[.toaster]:border-border group-[.toaster]:shadow-md group-[.toaster]:relative group-[.toaster]:pr-8",
          description: "group-[.toast]:text-black",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          closeButton:
            "!absolute !top-1/2 !-translate-y-1/2 !right-2 !left-auto !bg-transparent !border-none !shadow-none !text-[#1e3a5f] hover:!text-[#0f1d2f] !h-4 !w-4 !p-0 [&>svg]:!h-3.5 [&>svg]:!w-3.5 [&>svg]:!stroke-[2.5]",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
